export default __webpack_public_path__ + "static/media/coins.5a24b382.png";